/*
 * (c) Copyright, 2026, Medidata Solutions Worldwide, Inc. All rights reserved.
 *
 * EOS Status Graph Toggle Component
 *
 * Migrated from: lego/page/eos/overview/StatusGraphToggle/StatusGraphToggle.jsx
 *
 * Toggle button that switches between Summary and Detailed graph views.
 * Only shown in non-legacy (EOS 3.0) mode.
 */

import { useTranslation } from 'react-i18next'
import { Popover, OverlayTrigger } from 'react-bootstrap'
import type { EosStatusGraphToggleProps } from '../types'

const EosStatusGraphToggle: React.FC<EosStatusGraphToggleProps> = ({ toggleGraphView, filter, filterName }) => {
  const { t } = useTranslation()

  const handleToggle = () => {
    toggleGraphView(filterName)
  }

  const getPopoverReference = () => (
    <Popover id="goto-folder-popup-info">
      <div
        dangerouslySetInnerHTML={{
          __html: t(
            filter?.activity === 'SUMMARY'
              ? 'EOS_OVERVIEW_CHART_BTN_TOGGLE_DETAILED'
              : 'EOS_OVERVIEW_CHART_BTN_TOGGLE_SUMMARY'
          )
        }}
      ></div>
    </Popover>
  )

  return (
    <div
      className="pull-right pos-relative cursor-pointer eos-graph-toggle"
      onClick={handleToggle}
      style={{ top: '-20px' }}
    >
      {filter?.activity === 'SUMMARY' && (
        <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={getPopoverReference()}>
          <i className="etmf-graph-toggle-active"></i>
        </OverlayTrigger>
      )}
      {filter?.activity === 'DETAILED' && (
        <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={getPopoverReference()}>
          <i className="etmf-graph-toggle-muted"></i>
        </OverlayTrigger>
      )}
    </div>
  )
}

export default EosStatusGraphToggle
